module.exports = __webpack_public_path__ + "files/828aad60ddeeb5284c7b44b2b2fc8b08.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/roboto-bold-webfont.ttf
// module id = 755
// module chunks = 60